import { useAppSelector } from '@shared/store';
import { selectIsReadyToUseLK } from '@entities/account';

export const useAccountIsReadyToUseLK = () => {
  const isReady = useAppSelector(selectIsReadyToUseLK);

  return isReady;
};
